import React, { useState, useEffect } from 'react';
import styles from 'styles/pages/about-new/press-center/Pagination.module.css';
import { ReactComponent as SVGArrow } from 'images/pages/about-new/press-center/arrow.svg';

const Pagination = ({ controlledElement }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(Math.ceil(controlledElement.scrollWidth / controlledElement.offsetWidth));
    let onScrollTimeout;

    useEffect(() => {
        window.addEventListener('resize', () => setTotalPages(Math.ceil(controlledElement.scrollWidth / controlledElement.offsetWidth)));
        controlledElement.addEventListener('scroll', () => {
            clearTimeout(onScrollTimeout);
            onScrollTimeout = setTimeout(() => {
                setCurrentPage(Math.ceil(controlledElement.scrollLeft / controlledElement.offsetWidth) + 1);
            }, 300);
        });
        const observer = new ResizeObserver(() => {
            setTotalPages(Math.ceil(controlledElement.scrollWidth / controlledElement.offsetWidth));
        });

        observer.observe(controlledElement);
    }, []);

    useEffect(() => {
        controlledElement.scroll({
            left: controlledElement.offsetWidth * (currentPage - 1),
            behavior: 'smooth',
        });
    }, [currentPage, totalPages]);

    const visiblePages = (total, current) => {
        const allPages = [...Array(total).keys()].map((k) => k + 1);
        const indexOfCurrentPage = allPages.indexOf(current);
        let filteredPages = allPages.map((p, index) => {
            if (index >= indexOfCurrentPage - 2 && index <= indexOfCurrentPage + 2) {
                return p;
            }
            if (index === 0) {
                return p;
            }
            if (index === (allPages.length - 1)) {
                return p;
            }
            return null;
        });
        filteredPages = filteredPages.filter((p, index) => {
            if (p === null && filteredPages[index - 1] === null) {
                return false;
            }
            return true;
        });
        return filteredPages;
    };

    const selectPage = (page) => {
        clearTimeout(onScrollTimeout);
        setCurrentPage(page);
    };

    if (totalPages === 1) {
        return null;
    }

    return (
        <>
            <span
                href="#"
                onClick={(e) => { e.preventDefault(); selectPage(currentPage - 1); }}
                className={`${styles.prev} ${currentPage !== 1 && styles.visible}`}
            >
                <SVGArrow />
            </span>
            {visiblePages(totalPages, currentPage)
                .map((page, index) => (page !== null ? <span
                    key={index}
                    href="#"
                    onClick={(e) => { e.preventDefault(); selectPage(page); }}
                    className={`${styles.link} ${currentPage === page ? styles.current : ''}`}
                >
                    {page}
                </span>
                    : <span key={index}>...</span>))
            }
            <span
                href="#"
                onClick={(e) => { e.preventDefault(); selectPage(currentPage + 1); }}
                className={`${styles.next} ${currentPage !== totalPages && styles.visible}`}
            >
                <SVGArrow />
            </span>
        </>
    );
};

export default Pagination;
